import { defineComponent, onMounted } from 'vue';
import { MultiSelect } from '@studyportals/multiselect';
import RegionCode from '@/presentation/components/campaign-management/region/region.code';

export default defineComponent({
	components: {
		MultiSelect
	},
	setup: () => {
		const code = new RegionCode();

		onMounted(code.mounted.bind(code));

		return {
			regionDropdown: code.regionDropdown,
			options: code.options,
			setRegion: code.setRegion.bind(code)
		};
	}
});
